<template>
    <b-card-text>
        <template v-if="entities.data ? entities.data.length : false">
            <div class="d-flex flex-column">
                <div v-for="entity in entities.data" :key="entity.id">
                    <b-media vertical-align="center" class="mb-3">
                        <b-link @click="getLinkToProfile(entity)" slot="aside">
                            <avatar
                                :size="40"
                                :src="entity.user.picture"
                                :username="entity.user.name"
                                class="d-down-none"
                            />
                        </b-link>
                        <div>
                            <b-link :href="getLinkToEntity(entity)">
                                <p class="mb-0 text-small-sm-down text-justify">
                                    <strong>
                                        {{ entity.title }}
                                    </strong>
                                </p>
                            </b-link>
                            <div class="d-flex justify-content-between">
                                <p class="mb-0">
                                    <small class="text-muted">
                                        {{ entity.user.name }}
                                    </small>
                                </p>
                            </div>
                        </div>
                        <div>
                            <ProgressBar :value="convertProgressToPercentage(entity.progress)" />
                        </div>
                        <div class="d-flex justify-content-between">
                            <p class="mb-0 mt-2">
                                <section-badge :entity="entity" :entityType="entityType" />
                            </p>
                            <p class="mb-0 ml-auto">
                                <span class="text-muted">
                                    {{
                                        entity.progress
                                            ? `${formatPercentage(convertProgressToPercentage(entity.progress))}%`
                                            : '-'
                                    }}
                                </span>
                            </p>
                        </div>
                    </b-media>
                </div>
                <b-pagination
                    v-if="entities.last_page > 1"
                    class="mb-0 align-self-center"
                    :total-rows="entities.total"
                    :per-page="entities.per_page"
                    v-model="entities.current_page"
                    @change="onChangePaginationHandler"
                />
            </div>
        </template>
        <template v-else-if="isEntityListEmpty">
            <b-alert show variant="info">
                {{ $t(`reports.tags.notFoundInThisSearch.${entityType}`) }}
            </b-alert>
        </template>
    </b-card-text>
</template>

<script>
import Avatar from 'vue-avatar'
import ProgressBar from '@/views/components/progress-bar/ProgressBar'
import SectionBadge from './SectionBadge'
import { formatPercentage } from '@/lib/utils'
import { getV1PathWithOrigin } from '@/router/routesToV1'

export default {
    name: 'EntityList',
    props: ['entities', 'entityType', 'progress'],
    components: {
        Avatar,
        ProgressBar,
        SectionBadge,
    },
    methods: {
        formatPercentage(number) {
            return formatPercentage(number)
        },
        convertProgressToPercentage(number) {
            return this.entityType === 'goals' ? number : number * 100
        },
        onChangePaginationHandler(page) {
            this.$emit('changePage', {
                page,
                entityType: this.entityType,
            })
        },
        getLinkToEntity(entity) {
            switch (this.entityType) {
                case 'keyResults':
                    return `${getV1PathWithOrigin('/okr/objectives/key-results', {
                        objectiveId: entity.objective.id,
                        keyResultId: entity.id,
                    })}`
                case 'goals':
                    return {
                        path: `/v2/target/targets/view/${entity.id}`,
                    }
                case 'objectives':
                    return getV1PathWithOrigin('/okr/objectives', {
                        objectiveId: entity.id,
                    })
            }
        },
        getLinkToProfile(entity) {
            return this.$router.push({
                path: `/v2/profile/${entity.user_id}`,
            })
        },
    },
    computed: {
        isEntityListEmpty() {
            if (this.entities.data && !this.entities.data.length) {
                return true
            }
            return false
        },
    },
}
</script>
